import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface YearWithPoints {
  year: number;
  measurementPoints: { latitude: number; longitude: number }[];
}

@Component({
  selector: 'app-copy-from-year-dialog',
  template: `
    <h2 mat-dialog-title>Copy Measurement Points from Another Year</h2>
    <mat-dialog-content>
      @if (data.years.length === 0) {
        <p>No other years with measurement points available for this category.</p>
      } @else {
        <p>Select a year to copy measurement points from:</p>
        <mat-selection-list [multiple]="false" (selectionChange)="onSelectionChange($event)">
          @for (option of data.years; track option.year) {
            <mat-list-option [value]="option">
              {{ option.year }} &nbsp;
              <span style="color: gray; font-size: 0.85em">
                ({{ option.measurementPoints.length }} point{{ option.measurementPoints.length !== 1 ? 's' : '' }})
              </span>
            </mat-list-option>
          }
        </mat-selection-list>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-button color="primary" [disabled]="!selectedYear" (click)="confirm()">Copy</button>
    </mat-dialog-actions>
  `,
  standalone: false,
})
export class CopyFromYearDialogComponent {
  selectedYear: YearWithPoints | null = null;

  constructor(
    public dialogRef: MatDialogRef<CopyFromYearDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { years: YearWithPoints[] }
  ) {}

  onSelectionChange(event: any): void {
    this.selectedYear = event.options[0]?.value ?? null;
  }

  confirm(): void {
    this.dialogRef.close(this.selectedYear);
  }
}
